export const logs = [
  // {
  //     title: "offer.janowo.diary.timeline.february",
  //     year: 2025,
  //     pics: [
  //         [
  //         ],
  //         [
  //         ],
  //     ],
  //     alts: [],
  // },
  {
      title: "offer.janowo.diary.timeline.november",
      year: 2025,
      pics: [
          [
            "/assets/images/ojp3/diary/2025-11/willbud-rumia-1.jpg",
            "/assets/images/ojp3/diary/2025-11/willbud-rumia-2.jpg",
            "/assets/images/ojp3/diary/2025-11/willbud-rumia-3.jpg",
            "/assets/images/ojp3/diary/2025-11/willbud-rumia-4.jpg",
            "/assets/images/ojp3/diary/2025-11/willbud-rumia-5.jpg",
            "/assets/images/ojp3/diary/2025-11/willbud-rumia-6.jpg",
            "/assets/images/ojp3/diary/2025-11/willbud-rumia-7.jpg",
            "/assets/images/ojp3/diary/2025-11/willbud-rumia-8.jpg",
            "/assets/images/ojp3/diary/2025-11/willbud-rumia-9.jpg",
            "/assets/images/ojp3/diary/2025-11/willbud-rumia-10.jpg",
            "/assets/images/ojp3/diary/2025-11/willbud-rumia-11.jpg",
            "/assets/images/ojp3/diary/2025-11/willbud-rumia-12.jpg",
            "/assets/images/ojp3/diary/2025-11/willbud-rumia-13.jpg",
            "/assets/images/ojp3/diary/2025-11/willbud-rumia-14.jpg",
            "/assets/images/ojp3/diary/2025-11/willbud-rumia-15.jpg",
            "/assets/images/ojp3/diary/2025-11/willbud-rumia-16.jpg",
            "/assets/images/ojp3/diary/2025-11/willbud-rumia-17.jpg",
            "/assets/images/ojp3/diary/2025-11/willbud-rumia-18.jpg",
            "/assets/images/ojp3/diary/2025-11/willbud-rumia-19.jpg",
            "/assets/images/ojp3/diary/2025-11/willbud-rumia-20.jpg",
            "/assets/images/ojp3/diary/2025-11/willbud-rumia-21.jpg",
            "/assets/images/ojp3/diary/2025-11/willbud-rumia-22.jpg",
            "/assets/images/ojp3/diary/2025-11/willbud-rumia-23.jpg",
            "/assets/images/ojp3/diary/2025-11/willbud-rumia-24.jpg",

          ],
          [
            "/assets/images/ojp3/diary/2025-11/mini_willbud-rumia-1.jpg",
            "/assets/images/ojp3/diary/2025-11/mini_willbud-rumia-2.jpg",
            "/assets/images/ojp3/diary/2025-11/mini_willbud-rumia-3.jpg",
            "/assets/images/ojp3/diary/2025-11/mini_willbud-rumia-4.jpg",
            "/assets/images/ojp3/diary/2025-11/mini_willbud-rumia-5.jpg",
            "/assets/images/ojp3/diary/2025-11/mini_willbud-rumia-6.jpg",
            "/assets/images/ojp3/diary/2025-11/mini_willbud-rumia-7.jpg",
            "/assets/images/ojp3/diary/2025-11/mini_willbud-rumia-8.jpg",
            "/assets/images/ojp3/diary/2025-11/mini_willbud-rumia-9.jpg",
            "/assets/images/ojp3/diary/2025-11/mini_willbud-rumia-10.jpg",
            "/assets/images/ojp3/diary/2025-11/mini_willbud-rumia-11.jpg",
            "/assets/images/ojp3/diary/2025-11/mini_willbud-rumia-12.jpg",
            "/assets/images/ojp3/diary/2025-11/mini_willbud-rumia-13.jpg",
            "/assets/images/ojp3/diary/2025-11/mini_willbud-rumia-14.jpg",
            "/assets/images/ojp3/diary/2025-11/mini_willbud-rumia-15.jpg",
            "/assets/images/ojp3/diary/2025-11/mini_willbud-rumia-16.jpg",
            "/assets/images/ojp3/diary/2025-11/mini_willbud-rumia-17.jpg",
            "/assets/images/ojp3/diary/2025-11/mini_willbud-rumia-18.jpg",
            "/assets/images/ojp3/diary/2025-11/mini_willbud-rumia-19.jpg",
            "/assets/images/ojp3/diary/2025-11/mini_willbud-rumia-20.jpg",
            "/assets/images/ojp3/diary/2025-11/mini_willbud-rumia-21.jpg",
            "/assets/images/ojp3/diary/2025-11/mini_willbud-rumia-22.jpg",
            "/assets/images/ojp3/diary/2025-11/mini_willbud-rumia-23.jpg",
            "/assets/images/ojp3/diary/2025-11/mini_willbud-rumia-24.jpg",

          ],
      ],
      alts: [],
  },{
      title: "offer.janowo.diary.timeline.september",
      year: 2025,
      pics: [
          [
            "/assets/images/ojp3/diary/2025-09/rumia-willbud-1.jpg",
            "/assets/images/ojp3/diary/2025-09/rumia-willbud-2.jpg",
            "/assets/images/ojp3/diary/2025-09/rumia-willbud-3.jpg",
            "/assets/images/ojp3/diary/2025-09/rumia-willbud-4.jpg",
            "/assets/images/ojp3/diary/2025-09/rumia-willbud-5.jpg",
            "/assets/images/ojp3/diary/2025-09/rumia-willbud-6.jpg",
            "/assets/images/ojp3/diary/2025-09/rumia-willbud-7.jpg",
            "/assets/images/ojp3/diary/2025-09/rumia-willbud-8.jpg",
            "/assets/images/ojp3/diary/2025-09/rumia-willbud-9.jpg",
          ],
          [
            "/assets/images/ojp3/diary/2025-09/mini_rumia-willbud-1.jpg",
            "/assets/images/ojp3/diary/2025-09/mini_rumia-willbud-2.jpg",
            "/assets/images/ojp3/diary/2025-09/mini_rumia-willbud-3.jpg",
            "/assets/images/ojp3/diary/2025-09/mini_rumia-willbud-4.jpg",
            "/assets/images/ojp3/diary/2025-09/mini_rumia-willbud-5.jpg",
            "/assets/images/ojp3/diary/2025-09/mini_rumia-willbud-6.jpg",
            "/assets/images/ojp3/diary/2025-09/mini_rumia-willbud-7.jpg",
            "/assets/images/ojp3/diary/2025-09/mini_rumia-willbud-8.jpg",
            "/assets/images/ojp3/diary/2025-09/mini_rumia-willbud-9.jpg",
          ],
      ],
      alts: [],
  },{
      title: "offer.janowo.diary.timeline.july",
      year: 2025,
      pics: [
          [
            "/assets/images/ojp3/diary/2025-07/IMG_20250708_112409196.jpg",
            "/assets/images/ojp3/diary/2025-07/IMG_20250708_112434723.jpg",
            "/assets/images/ojp3/diary/2025-07/IMG_20250708_112526968.jpg",
            "/assets/images/ojp3/diary/2025-07/IMG_20250708_113050857_HDR.jpg",
            "/assets/images/ojp3/diary/2025-07/IMG_20250708_113118422.jpg",
            "/assets/images/ojp3/diary/2025-07/IMG_20250708_113218339.jpg",
            "/assets/images/ojp3/diary/2025-07/IMG_20250708_113321239_HDR.jpg",
            "/assets/images/ojp3/diary/2025-07/IMG_20250708_113445901.jpg",
            "/assets/images/ojp3/diary/2025-07/IMG_20250708_113449561.jpg",
            "/assets/images/ojp3/diary/2025-07/IMG_20250708_113534610.jpg",
            "/assets/images/ojp3/diary/2025-07/IMG_20250708_113700284_HDR.jpg",
            "/assets/images/ojp3/diary/2025-07/IMG_20250708_113829427_HDR.jpg",
            "/assets/images/ojp3/diary/2025-07/IMG_20250708_113905844.jpg",
            "/assets/images/ojp3/diary/2025-07/IMG_20250708_114519258_HDR.jpg",

          ],
          [
            "/assets/images/ojp3/diary/2025-07/mini_IMG_20250708_112409196.jpg",
            "/assets/images/ojp3/diary/2025-07/mini_IMG_20250708_112434723.jpg",
            "/assets/images/ojp3/diary/2025-07/mini_IMG_20250708_112526968.jpg",
            "/assets/images/ojp3/diary/2025-07/mini_IMG_20250708_113050857_HDR.jpg",
            "/assets/images/ojp3/diary/2025-07/mini_IMG_20250708_113118422.jpg",
            "/assets/images/ojp3/diary/2025-07/mini_IMG_20250708_113218339.jpg",
            "/assets/images/ojp3/diary/2025-07/mini_IMG_20250708_113321239_HDR.jpg",
            "/assets/images/ojp3/diary/2025-07/mini_IMG_20250708_113445901.jpg",
            "/assets/images/ojp3/diary/2025-07/mini_IMG_20250708_113449561.jpg",
            "/assets/images/ojp3/diary/2025-07/mini_IMG_20250708_113534610.jpg",
            "/assets/images/ojp3/diary/2025-07/mini_IMG_20250708_113700284_HDR.jpg",
            "/assets/images/ojp3/diary/2025-07/mini_IMG_20250708_113829427_HDR.jpg",
            "/assets/images/ojp3/diary/2025-07/mini_IMG_20250708_113905844.jpg",
            "/assets/images/ojp3/diary/2025-07/mini_IMG_20250708_114519258_HDR.jpg",

          ],
      ],
      alts: [],
  },{
      title: "offer.janowo.diary.timeline.june",
      year: 2025,
      pics: [
          [
            "/assets/images/ojp3/diary/2025-06/IMG_20250611_111548074.jpg",
            "/assets/images/ojp3/diary/2025-06/IMG_20250611_111647092.jpg",
            "/assets/images/ojp3/diary/2025-06/IMG_20250611_112215263.jpg",
            "/assets/images/ojp3/diary/2025-06/IMG_20250611_112259444_HDR.jpg",
            "/assets/images/ojp3/diary/2025-06/IMG_20250611_112308839.jpg",
            "/assets/images/ojp3/diary/2025-06/IMG_20250611_113254054.jpg",
            "/assets/images/ojp3/diary/2025-06/IMG_20250611_113256049.jpg",
            "/assets/images/ojp3/diary/2025-06/IMG_20250611_113352081.jpg",
            "/assets/images/ojp3/diary/2025-06/IMG_20250611_113355690.jpg",

          ],
          [
            "/assets/images/ojp3/diary/2025-06/mini_IMG_20250611_111548074.jpg",
            "/assets/images/ojp3/diary/2025-06/mini_IMG_20250611_111647092.jpg",
            "/assets/images/ojp3/diary/2025-06/mini_IMG_20250611_112215263.jpg",
            "/assets/images/ojp3/diary/2025-06/mini_IMG_20250611_112259444_HDR.jpg",
            "/assets/images/ojp3/diary/2025-06/mini_IMG_20250611_112308839.jpg",
            "/assets/images/ojp3/diary/2025-06/mini_IMG_20250611_113254054.jpg",
            "/assets/images/ojp3/diary/2025-06/mini_IMG_20250611_113256049.jpg",
            "/assets/images/ojp3/diary/2025-06/mini_IMG_20250611_113352081.jpg",
            "/assets/images/ojp3/diary/2025-06/mini_IMG_20250611_113355690.jpg",

          ],
      ],
      alts: [],
  },{
      title: "offer.janowo.diary.timeline.april",
      year: 2025,
      pics: [
          [
            "/assets/images/ojp3/diary/2025-04/20250426_104718.jpg",
            "/assets/images/ojp3/diary/2025-04/20250426_104806.jpg",
            "/assets/images/ojp3/diary/2025-04/20250426_104824.jpg",
            "/assets/images/ojp3/diary/2025-04/20250426_104912.jpg",
            "/assets/images/ojp3/diary/2025-04/20250426_105244.jpg",
            "/assets/images/ojp3/diary/2025-04/20250426_105311.jpg",
            "/assets/images/ojp3/diary/2025-04/20250426_105340.jpg",
            "/assets/images/ojp3/diary/2025-04/20250426_105411.jpg",
            "/assets/images/ojp3/diary/2025-04/20250426_105431.jpg",
            "/assets/images/ojp3/diary/2025-04/20250426_105457.jpg",
            "/assets/images/ojp3/diary/2025-04/20250426_105519.jpg",
            "/assets/images/ojp3/diary/2025-04/20250426_105641.jpg",
            "/assets/images/ojp3/diary/2025-04/20250426_105718.jpg",

          ],
          [
            "/assets/images/ojp3/diary/2025-04/mini_20250426_104718.jpg",
            "/assets/images/ojp3/diary/2025-04/mini_20250426_104806.jpg",
            "/assets/images/ojp3/diary/2025-04/mini_20250426_104824.jpg",
            "/assets/images/ojp3/diary/2025-04/mini_20250426_104912.jpg",
            "/assets/images/ojp3/diary/2025-04/mini_20250426_105244.jpg",
            "/assets/images/ojp3/diary/2025-04/mini_20250426_105311.jpg",
            "/assets/images/ojp3/diary/2025-04/mini_20250426_105340.jpg",
            "/assets/images/ojp3/diary/2025-04/mini_20250426_105411.jpg",
            "/assets/images/ojp3/diary/2025-04/mini_20250426_105431.jpg",
            "/assets/images/ojp3/diary/2025-04/mini_20250426_105457.jpg",
            "/assets/images/ojp3/diary/2025-04/mini_20250426_105519.jpg",
            "/assets/images/ojp3/diary/2025-04/mini_20250426_105641.jpg",
            "/assets/images/ojp3/diary/2025-04/mini_20250426_105718.jpg",
          ],
      ],
      alts: [],
  },

  {
      title: "offer.janowo.diary.timeline.february",
      year: 2025,
      pics: [
          [
            "/assets/images/ojp3/diary/2025-02/20250226_082610.jpg",
            "/assets/images/ojp3/diary/2025-02/20250226_082612.jpg",
            "/assets/images/ojp3/diary/2025-02/20250226_082614.jpg",
            "/assets/images/ojp3/diary/2025-02/20250226_082616.jpg",
            "/assets/images/ojp3/diary/2025-02/20250226_082618.jpg",
            "/assets/images/ojp3/diary/2025-02/20250226_082620.jpg",
            "/assets/images/ojp3/diary/2025-02/20250226_082638.jpg",
            "/assets/images/ojp3/diary/2025-02/20250226_082850.jpg",
            "/assets/images/ojp3/diary/2025-02/20250226_082920.jpg",
            "/assets/images/ojp3/diary/2025-02/20250226_082922.jpg",
            "/assets/images/ojp3/diary/2025-02/20250226_082924.jpg",
            "/assets/images/ojp3/diary/2025-02/20250226_082926.jpg",
            "/assets/images/ojp3/diary/2025-02/20250226_084844.jpg",
            "/assets/images/ojp3/diary/2025-02/20250226_084846.jpg",
            "/assets/images/ojp3/diary/2025-02/20250226_084848.jpg",
            "/assets/images/ojp3/diary/2025-02/20250226_084852.jpg",
            "/assets/images/ojp3/diary/2025-02/20250226_084854.jpg",
            "/assets/images/ojp3/diary/2025-02/20250226_084856.jpg",
            "/assets/images/ojp3/diary/2025-02/20250226_084900.jpg",
            "/assets/images/ojp3/diary/2025-02/20250226_084911.jpg",
            "/assets/images/ojp3/diary/2025-02/20250226_084915.jpg",

          ],
          [
            "/assets/images/ojp3/diary/2025-02/mini_20250226_082610.jpg",
            "/assets/images/ojp3/diary/2025-02/mini_20250226_082612.jpg",
            "/assets/images/ojp3/diary/2025-02/mini_20250226_082614.jpg",
            "/assets/images/ojp3/diary/2025-02/mini_20250226_082616.jpg",
            "/assets/images/ojp3/diary/2025-02/mini_20250226_082618.jpg",
            "/assets/images/ojp3/diary/2025-02/mini_20250226_082620.jpg",
            "/assets/images/ojp3/diary/2025-02/mini_20250226_082638.jpg",
            "/assets/images/ojp3/diary/2025-02/mini_20250226_082850.jpg",
            "/assets/images/ojp3/diary/2025-02/mini_20250226_082920.jpg",
            "/assets/images/ojp3/diary/2025-02/mini_20250226_082922.jpg",
            "/assets/images/ojp3/diary/2025-02/mini_20250226_082924.jpg",
            "/assets/images/ojp3/diary/2025-02/mini_20250226_082926.jpg",
            "/assets/images/ojp3/diary/2025-02/mini_20250226_084844.jpg",
            "/assets/images/ojp3/diary/2025-02/mini_20250226_084846.jpg",
            "/assets/images/ojp3/diary/2025-02/mini_20250226_084848.jpg",
            "/assets/images/ojp3/diary/2025-02/mini_20250226_084852.jpg",
            "/assets/images/ojp3/diary/2025-02/mini_20250226_084854.jpg",
            "/assets/images/ojp3/diary/2025-02/mini_20250226_084856.jpg",
            "/assets/images/ojp3/diary/2025-02/mini_20250226_084900.jpg",
            "/assets/images/ojp3/diary/2025-02/mini_20250226_084911.jpg",
            "/assets/images/ojp3/diary/2025-02/mini_20250226_084915.jpg",

          ],
      ],
      alts: [],
  }, {
    title: "offer.janowo.diary.timeline.october",
    year: 2024,
    pics: [
      [
        "/assets/images/ojp3/diary/2024-10/20241025_160518.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_160600.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_160646.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_160732.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_161251.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_161322.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_161347.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_161426.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_161456.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_161502.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_161531.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_161539.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_161545.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_161549.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_161613.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_161630.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_161643.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_161646.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_161655.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_161753.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_161758.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_161923.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_161937.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_161957.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_162010.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_162014.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_162102.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_162114.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_162124.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_162210.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_162244.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_162627.jpg",
        "/assets/images/ojp3/diary/2024-10/20241025_163020.jpg",
      ],
      [
        "/assets/images/ojp3/diary/2024-10/mini_20241025_160518.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_160600.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_160646.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_160732.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_161251.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_161322.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_161347.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_161426.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_161456.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_161502.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_161531.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_161539.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_161545.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_161549.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_161613.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_161630.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_161643.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_161646.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_161655.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_161753.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_161758.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_161923.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_161937.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_161957.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_162010.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_162014.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_162102.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_162114.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_162124.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_162210.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_162244.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_162627.jpg",
        "/assets/images/ojp3/diary/2024-10/mini_20241025_163020.jpg",
      ],
    ],
    alts: [],
  },
  {
    title: "offer.janowo.diary.timeline.september",
    year: 2024,
    pics: [
      [
        "/assets/images/ojp3/diary/2024-09/20240925_165556.jpg",
        "/assets/images/ojp3/diary/2024-09/20240925_165624.jpg",
        "/assets/images/ojp3/diary/2024-09/20240925_165627.jpg",
        "/assets/images/ojp3/diary/2024-09/20240925_165733.jpg",
        "/assets/images/ojp3/diary/2024-09/20240925_165816.jpg",
        "/assets/images/ojp3/diary/2024-09/20240925_165840.jpg",
        "/assets/images/ojp3/diary/2024-09/20240925_165959.jpg",
        "/assets/images/ojp3/diary/2024-09/20240925_170101.jpg",
        "/assets/images/ojp3/diary/2024-09/20240925_170123.jpg",
      ],
      [
        "/assets/images/ojp3/diary/2024-09/mini_20240925_165556.jpg",
        "/assets/images/ojp3/diary/2024-09/mini_20240925_165624.jpg",
        "/assets/images/ojp3/diary/2024-09/mini_20240925_165627.jpg",
        "/assets/images/ojp3/diary/2024-09/mini_20240925_165733.jpg",
        "/assets/images/ojp3/diary/2024-09/mini_20240925_165816.jpg",
        "/assets/images/ojp3/diary/2024-09/mini_20240925_165840.jpg",
        "/assets/images/ojp3/diary/2024-09/mini_20240925_165959.jpg",
        "/assets/images/ojp3/diary/2024-09/mini_20240925_170101.jpg",
        "/assets/images/ojp3/diary/2024-09/mini_20240925_170123.jpg",
      ],
    ],
    alts: [],
  },
  {
    title: "offer.janowo.diary.timeline.july",
    year: 2024,
    pics: [
      [
        "/assets/images/ojp3/diary/2024-07/20240701_105127.jpg",
        // "/assets/images/ojp3/diary/2024-07/20240701_113641.jpg",
        // "/assets/images/ojp3/diary/2024-07/20240701_113644.jpg",
        "/assets/images/ojp3/diary/2024-07/20240703_102652.jpg",
        "/assets/images/ojp3/diary/2024-07/20240704_104127.jpg",
        "/assets/images/ojp3/diary/2024-07/20240704_104145.jpg",
        "/assets/images/ojp3/diary/2024-07/20240717_133129.jpg",
        "/assets/images/ojp3/diary/2024-07/20240719_083149.jpg",
        "/assets/images/ojp3/diary/2024-07/20240719_085236.jpg",
        "/assets/images/ojp3/diary/2024-07/20240720_120552.jpg",
        "/assets/images/ojp3/diary/2024-07/20240720_120554.jpg",
        "/assets/images/ojp3/diary/2024-07/IMG_20240722_122033_608.jpg",
        "/assets/images/ojp3/diary/2024-07/IMG_20240729_071435_968.jpg",
      ],
      [
        "/assets/images/ojp3/diary/2024-07/mini_20240701_105127.jpg",
        // "/assets/images/ojp3/diary/2024-07/mini_20240701_113641.jpg",
        // "/assets/images/ojp3/diary/2024-07/mini_20240701_113644.jpg",
        "/assets/images/ojp3/diary/2024-07/mini_20240703_102652.jpg",
        "/assets/images/ojp3/diary/2024-07/mini_20240704_104127.jpg",
        "/assets/images/ojp3/diary/2024-07/mini_20240704_104145.jpg",
        "/assets/images/ojp3/diary/2024-07/mini_20240717_133129.jpg",
        "/assets/images/ojp3/diary/2024-07/mini_20240719_083149.jpg",
        "/assets/images/ojp3/diary/2024-07/mini_20240719_085236.jpg",
        "/assets/images/ojp3/diary/2024-07/mini_20240720_120552.jpg",
        "/assets/images/ojp3/diary/2024-07/mini_20240720_120554.jpg",
        "/assets/images/ojp3/diary/2024-07/mini_IMG_20240722_122033_608.jpg",
        "/assets/images/ojp3/diary/2024-07/mini_IMG_20240729_071435_968.jpg",
      ],
    ],
    alts: [],
  },
  {
    title: "offer.janowo.diary.timeline.june",
    year: 2024,
    pics: [
      [
        "/assets/images/ojp3/diary/2024-06/20240701_105124.jpg",
        "/assets/images/ojp3/diary/2024-06/20240701_113641.jpg",
        "/assets/images/ojp3/diary/2024-06/20240701_113644.jpg",
        "/assets/images/ojp3/diary/2024-06/20240703_102723.jpg",
        "/assets/images/ojp3/diary/2024-06/20240704_061027.jpg",
        "/assets/images/ojp3/diary/2024-06/20240704_104115.jpg",
        "/assets/images/ojp3/diary/2024-06/20240704_104127.jpg",
        "/assets/images/ojp3/diary/2024-06/20240704_104140.jpg",
        "/assets/images/ojp3/diary/2024-06/20240708_112355.jpg",
      ],
      [
        "/assets/images/ojp3/diary/2024-06/mini_20240701_105124.jpg",
        "/assets/images/ojp3/diary/2024-06/mini_20240701_113641.jpg",
        "/assets/images/ojp3/diary/2024-06/mini_20240701_113644.jpg",
        "/assets/images/ojp3/diary/2024-06/mini_20240703_102723.jpg",
        "/assets/images/ojp3/diary/2024-06/mini_20240704_061027.jpg",
        "/assets/images/ojp3/diary/2024-06/mini_20240704_104115.jpg",
        "/assets/images/ojp3/diary/2024-06/mini_20240704_104127.jpg",
        "/assets/images/ojp3/diary/2024-06/mini_20240704_104140.jpg",
        "/assets/images/ojp3/diary/2024-06/mini_20240708_112355.jpg",
      ],
    ],
    alts: [],
  },
]
